"use client";

import { useEffect } from "react";
import { getDeviceId } from "@/lib/device-fingerprint";

export default function DeviceFingerprint() {
  useEffect(() => {
    getDeviceId();
  }, []);

  return null;
}
